import { ApplicationState, initialApplicationState, ImageFile } from './application.state';
import {
  SetProblemMenuConfigItems, SetContactInfo, SetCurrentStep,
  SetSelectedCoordinates,
  SetSelectedProblemMenuItemConfig, SetSelectedProblemMenuItemSuccess, SetUnmodifiableMenuConfig,
  GetProblemQuestionsSuccess, SubmitPhoto, RemovePhoto, SetAnsweredProblemQuestions,
  SavePhoto, UpdatePhotoUploadStatus, ImageFileStatusUpdate, ValidatePhotoUpload, ConvertProblemQuestionsSuccess
} from '.';

import {
  ApplicationAction, ApplicationActionType, ClearSelectedProblemMenuItemSuccess, SetFilterProblemMenuItemCount, SetProblemDetails,
  SetSelectedLocationName, SetSelectedLocationNameOrigin, UpdateProblemMenuDropdownState, CreateProblemStub, CreateProblemStubSuccess
} from './application.action';

function removeProblemPhoto(problemPhotos: ImageFile[], removePhoto: RemovePhoto): ImageFile[] {
  const index = problemPhotos.findIndex(photo => photo.hash === removePhoto.payload);
  if (index === -1) {
    return problemPhotos;
  }

  return [...problemPhotos.slice(0, index), ...problemPhotos.slice(index + 1)];
}

function updatePhotoStatus(problemPhotos: ImageFile[], updatedPhoto: ImageFile): ImageFile[] {
    const index = problemPhotos.findIndex(problemPhoto => problemPhoto.hash === updatedPhoto.hash);
    if (index === -1) {
        return problemPhotos;
    }

    return [
        ...problemPhotos.slice(0, index),
        {
            ...problemPhotos[index],
            progress: updatedPhoto.progress,
            imageStatus: updatedPhoto.imageStatus
        },
        ...problemPhotos.slice(index + 1)
    ];
}

export function applicationReducer(
  state: ApplicationState = initialApplicationState,
  action: ApplicationAction): ApplicationState {

  switch (action.type) {
    case ApplicationActionType.SetProblemMenuConfigItems:
      return Object.assign({}, state, {
        newProblemMenuItems: (action as SetProblemMenuConfigItems).payload
      });

    case ApplicationActionType.GetProblemMenuConfigError:
      return Object.assign({}, state, {
        newProblemMenuItems: []
      });

    case ApplicationActionType.SetUnmodifiableMenuConfig:
      return Object.assign({}, state, {
        unModifiedMenuItems: (action as SetUnmodifiableMenuConfig).payload
      });

    case ApplicationActionType.SetFilterProblemMenuItemCount:
      return Object.assign({}, state, {
        filteredProblemMenuItemsCount: (action as SetFilterProblemMenuItemCount).payload
      });

    case ApplicationActionType.UpdateProblemMenuDropdownState:
      return Object.assign({}, state, {
        newProblemMenuItems: (action as UpdateProblemMenuDropdownState).payload
      });

    case ApplicationActionType.SetCurrentStep:
      return Object.assign({}, state, {
        currentStep: (action as SetCurrentStep).payload
      });

    case ApplicationActionType.SetSelectedProblemMenuItemConfig:
      return Object.assign({}, state, {
        selectedProblemMenuItem: (action as SetSelectedProblemMenuItemConfig).payload
      });

    case ApplicationActionType.SetSelectedProblemMenuItemSuccess:
      return Object.assign({}, state, {
        newProblemMenuItems: (action as SetSelectedProblemMenuItemSuccess).payload
      });

    case ApplicationActionType.SetSelectedCoordinates:
      return Object.assign({}, state, {
        selectedLatLng: (action as SetSelectedCoordinates).payload
      });

    case ApplicationActionType.SetSelectedLocationNameOrigin:
      return Object.assign({}, state, {
        problemLocationOrigin: (action as SetSelectedLocationNameOrigin).payload
      });

    case ApplicationActionType.SetSelectedLocationName:
      return Object.assign({}, state, {
        problemLocation: (action as SetSelectedLocationName).payload
      });

    case ApplicationActionType.SetProblemDetails:
      return Object.assign({}, state, {
        problemDetails: (action as SetProblemDetails).payload
      });

    case ApplicationActionType.ValidatePhotoUpload:
      const index = state.problemPhotos.findIndex(problemPhoto => problemPhoto.hash === (action as ValidatePhotoUpload).payload?.hash);
      if (index === -1) {
        return Object.assign({}, state, {
          problemPhotos: [...state.problemPhotos, (action as ValidatePhotoUpload).payload]
        });
      } else {
        return state;
      }

    // case ApplicationActionType.SubmitPhoto:
    //   // Don't add the new photo if the file name already exist
    //   if (state.problemPhotos.find(p => p.file.name === (action as SubmitPhoto).payload.file?.name)) {
    //     return state;
    //   } else {
    //     return Object.assign({}, state, {
    //       problemPhotos: [...state.problemPhotos, {
    //         file: (action as SubmitPhoto).payload.file,
    //         source: '',
    //         hash: '',
    //         dataURL: (action as SubmitPhoto).payload.event?.target?.result,
    //         imageStatus: 'uploading'
    //       }]
    //     });
    //   }


    // case ApplicationActionType.SavePhoto:
    //   return Object.assign({}, state, {
    //     problemPhotos: [...state.problemPhotos, (action as SavePhoto).payload]
    //   });

    case ApplicationActionType.UpdatePhotoUploadStatus:
        return Object.assign({}, state, {
            problemPhotos: updatePhotoStatus(state.problemPhotos, (action as UpdatePhotoUploadStatus).payload)
        });

    case ApplicationActionType.RemovePhoto:
      return Object.assign({}, state, {
        problemPhotos: removeProblemPhoto(state.problemPhotos, (action as RemovePhoto))
      });

    case ApplicationActionType.RemoveErrorPhotos:
      return Object.assign({}, state, {
        problemPhotos: state.problemPhotos.filter(photo => photo.imageStatus !== 'rejected')
      });

    case ApplicationActionType.SetContactInfo:
      return Object.assign({}, state, {
        contactInfo: (action as SetContactInfo).payload
      });

    case ApplicationActionType.ClearSelectedProblemMenuItem:
      return Object.assign({}, state, {
        selectedProblemMenuItem: {
          ProblemMenuConfig_RefId: 0,
          ProblemType_RefId: 0,
          Group_RefId: 0,
          MenuOne: '',
          MenuTwo: '',
          MenuThree: '',
          messageDisplay: '',
          selected: false
        }
      });

    case ApplicationActionType.ClearSelectedProblemMenuItemSuccess:
      return Object.assign({}, state, {
        newProblemMenuItems: (action as ClearSelectedProblemMenuItemSuccess).payload
      });

    case ApplicationActionType.ClearSelectedLatLngCoordinates:
      return Object.assign({}, state, {
        selectedLatLng: { lat: 0, lng: 0 },
        problemLocation: "",
        problemLocationOrigin: ""
      });

    case ApplicationActionType.ClearProblemDetails:
      return Object.assign({}, state, {
        problemDetails: ''
      });

    case ApplicationActionType.ClearProblemPhotos:
      return Object.assign({}, state, {
        problemPhotos: []
      });

    case ApplicationActionType.ClearContactInfo:
      return Object.assign({}, state, {
        contactInfo: {
          firstName: '',
          lastName: '',
          address: '',
          email: '',
          phone: [],
          notificationsRequested: false
        }
      });

    case ApplicationActionType.CreateProblemStub:
      return Object.assign({}, state, {
        newProblemUniqueId: (new Date()).toJSON()
      });

    case ApplicationActionType.CreateProblemStubSuccess:
      return Object.assign({}, state, {
        newProblemUniqueId: (action as CreateProblemStubSuccess).payload,
      });

    // case ApplicationActionType.CreateProblemStubError:
    //   return Object.assign({}, state, {
    //     newProblemUniqueId: (new Date()).toJSON()
    //   });

    case ApplicationActionType.GetProblemQuestions:
      return Object.assign({}, state, {
        problemQuestions: []
      });

    case ApplicationActionType.GetProblemQuestionsSuccess:
      return Object.assign({}, state, {
        problemQuestions: (action as GetProblemQuestionsSuccess).payload
      });

    case ApplicationActionType.GetProblemQuestionsError:
      return Object.assign({}, state, {
        problemQuestions: []
      });

    case ApplicationActionType.ConvertProblemQuestions:
      return Object.assign({}, state, {
        problemQuestions: []
      });

    case ApplicationActionType.ConvertProblemQuestionsSuccess:
      return Object.assign({}, state, {
        problemQuestions: (action as ConvertProblemQuestionsSuccess).payload
      });

    case ApplicationActionType.SetAnsweredProblemQuestions:
      return Object.assign({}, state, {
        problemQuestions: (action as SetAnsweredProblemQuestions).payload
      });

    case ApplicationActionType.ResetAnsweredProblemQuestions:
      return Object.assign({}, state, {
        problemQuestions: []
      });

    case ApplicationActionType.ResetState:
      return Object.assign({}, state, {
        newProblemMenuItems: JSON.parse(JSON.stringify(state.unModifiedMenuItems)),
        filteredProblemMenuItemsCount: 0,
        selectedProblemMenuItem: {
            ProblemMenuConfig_RefId: 0,
            ProblemType_RefId: 0,
            Group_RefId: 0,
            MenuOne: '',
            MenuTwo: '',
            MenuThree: '',
            messageDisplay: '',
            selected: false,
            CanCreateCodeCase: false,
            AdditionalQuestions: []
        },
        problemLocation: '',
        problemLocationOrigin: '',
        furtherDetails: '',
        currentStep: 1,
        problemDetails: '',
        problemPhotos: [],
        contactInfo: {
            firstName: '',
            lastName: '',
            address: '',
            email: '',
            phone: [],
            notificationsRequested: false
        },
        selectedLatLng: {
            lat: 0,
            lng: 0
        },
        newProblemUniqueId: '',
        problemQuestions: []
      });

    default:
      return state;
  }
}
